import { Popup, Icon, List } from "semantic-ui-react";
import { AlertIcon } from "../index";

const styles = {
	errorPopup: {},
};

const GeslabWarningTab = ({ t, geslabAlert }) => {
	return (
		<span>
			<Icon name="comment alternate outline" size="small" /> {t("subMenu.alert")}
			{geslabAlert && <AlertIcon />}
		</span>
	);
};

export default GeslabWarningTab;
